// 입고예정 통합관리(옛 이름 «입고 CAPA 모니터링» · 메뉴 키 inbound-capa 그대로 · req-20261023-134507-cf5b36 · req-20261026-095719-d5a8b9 P4).
// 탭: «CAPA 모니터링»(MonitorTab · 기본) · «17시 마감 기록»(CloseTab — 옛 센터 일별 실적 «입고예정» 탭)
//     · «CAPA·알림 설정»(SettingsTab) · «SKU 적재 기준»(SkuTab) — 모두 pages/inboundCapa/.
// 모니터링 탭의 [CAPA · 알림 설정]·미설정 목록은 설정 탭으로(onGoSettings) · «환산 기준 보기»는 SKU 탭 미등록 목록으로(onShowUnregistered).
// 메뉴 노출·URL 가드는 utils/menuAccess(운영·시스템 관리자 + 명시 허용) · 실제 차단은 서버(require_menu("inbound-capa")).
// 센터 범위·규칙 수정 권한은 서버 /api/inbound-capa/me 가 정한다(이 화면은 그 값을 그대로 쓴다).
// 주소 `?date=YYYY-MM-DD&unit=<단위 id>` — 날짜 탭·상세를 주소로 공유한다(새로 열어도 같은 화면).
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import AppShell from '../components/AppShell';
import { inboundCapaAPI } from '../api/client';
import CloseTab from './inboundCapa/CloseTab';
import MonitorTab from './inboundCapa/MonitorTab';
import SettingsTab from './inboundCapa/SettingsTab';
import SkuTab from './inboundCapa/SkuTab';
import { COLORS } from '../utils/uiStyles';

const PAGE_TITLE = '입고예정 통합관리';
const TABS = [['monitor', 'CAPA 모니터링'], ['close', '17시 마감 기록'], ['settings', 'CAPA·알림 설정'], ['sku', 'SKU 적재 기준']];
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const UNIT_RE = /^\d+$/;

export default function InboundCapaPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawDate = searchParams.get('date') || '';
  const rawUnit = searchParams.get('unit') || '';
  const date = DATE_RE.test(rawDate) ? rawDate : '';
  const unit = UNIT_RE.test(rawUnit) ? rawUnit : '';
  const [tab, setTab] = useState('monitor');
  const [skuFocus, setSkuFocus] = useState('');
  const [me, setMe] = useState(null);
  const [meError, setMeError] = useState('');
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    inboundCapaAPI.me()
      .then((r) => { if (mountedRef.current) setMe(r.data || null); })
      .catch((err) => {
        if (!mountedRef.current) return;
        const detail = err?.response?.data?.detail;
        setMeError(typeof detail === 'string' && detail ? detail : '권한 정보를 불러오지 못했습니다.');
      });
    return () => { mountedRef.current = false; };
  }, []);

  // 빈 값은 주소에서 뺀다 — `?unit=` 처럼 빈 칸이 남지 않게.
  const setQuery = useCallback(({ date: nextDate, unit: nextUnit }) => {
    const next = new URLSearchParams();
    if (nextDate) next.set('date', nextDate);
    if (nextUnit) next.set('unit', String(nextUnit));
    setSearchParams(next);
  }, [setSearchParams]);

  const pickTab = (key) => { setSkuFocus(''); setTab(key); };
  const showUnregistered = () => { setSkuFocus('unregistered'); setTab('sku'); };
  const goSettings = () => pickTab('settings');

  return (
    <AppShell app="inbound-capa">
      <main style={{ flex: 1, minWidth: 0, height: 'var(--gw-app-h, 100dvh)', overflow: 'auto', background: COLORS.bg }}>
        <div style={{ padding: '16px', maxWidth: '1400px', boxSizing: 'border-box' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '14px', flexWrap: 'wrap' }}>
            <h2 style={{ margin: 0, fontSize: '20px' }}>{PAGE_TITLE}</h2>
            {me?.view_all && <span style={{ fontSize: '12px', color: COLORS.textSub }}>전 센터 열람</span>}
          </div>

          <div role="tablist" aria-label={PAGE_TITLE} style={{ display: 'flex', gap: '4px', borderBottom: `1px solid ${COLORS.border}`, marginBottom: '12px' }}>
            {TABS.map(([key, label]) => (
              <button key={key} type="button" role="tab" aria-selected={tab === key}
                onClick={() => pickTab(key)}
                style={{ padding: '8px 14px', border: 'none', borderBottom: `2px solid ${tab === key ? COLORS.primary : 'transparent'}`, background: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: tab === key ? 700 : 500, color: tab === key ? COLORS.primaryDark : COLORS.textSub }}>
                {label}
              </button>
            ))}
          </div>

          {meError && <div role="alert" style={{ color: COLORS.dangerText, fontSize: '12px', marginBottom: '8px' }}>{meError}</div>}
          {tab === 'monitor' && (
            <MonitorTab me={me} date={date} unit={unit} onQuery={setQuery} onGoSettings={goSettings} onShowUnregistered={showUnregistered} />
          )}
          {tab === 'close' && <CloseTab me={me} />}
          {tab === 'settings' && <SettingsTab me={me} />}
          {tab === 'sku' && <SkuTab me={me} focus={skuFocus} />}
        </div>
      </main>
    </AppShell>
  );
}
